module.exports = __webpack_public_path__ + "media/bom/part-no-image-0ef49c4a.jpg";